export enum TriggerType {
  ExitIntent = 'Exit intent',
  Inactivity = 'Inactivity',
  OnClick = 'On click',
  PageLoad = 'Page load',
}
